import { Component, OnInit } from '@angular/core';
import { AppState, FormItem } from '../../models/app-state';
import { AppFlowService } from '../../services/app-flow.service';
import { Router } from '@angular/router';
import { reduce } from 'lodash';
import { SessionStorageService } from '../../services/session-storage.service';
import { EnvConfig } from '../../models/env-config';

@Component({
  selector: 'app-confirmed-page',
  templateUrl: './confirmed-page.component.html',
  styleUrls: ['./confirmed-page.component.scss'],
})
export class ConfirmedPageComponent implements OnInit {
  envConfig: EnvConfig;
  messageTitle: string = '';
  messageBody: string = '';
  messageFooter: string = '';

  interpolateText(text: string, key: string, value: string): string {
    return text.replace(`{{${key}}}`, value);
  }

  constructor(
    private sessionStorageService: SessionStorageService,
    private appFlowService: AppFlowService,
    private router: Router
  ) {
    this.envConfig = sessionStorageService.getEnvConfig();
  }

  ngOnInit(): void {

    const appState: AppState = this.appFlowService.getAppState();
    
    this.messageTitle = this.envConfig['message.confirmed.title'] || '';
    this.messageBody = this.envConfig['message.confirmed.body'] || '';
    this.messageFooter = this.envConfig['message.sent.footer'] || '';

    this.appFlowService.clearAppState();
  }

  appRedirect(): void {
    const urlRedirect = this.envConfig['urlAppRedirect'];
    window.open(urlRedirect, '_blank');
  }
}